export const CREATE_PACKAGE_SAME_BARCODE = {
    REQUEST: 'PACKAGE.CREATE_PACKAGE_SAME_BARCODE.REQUEST',
    SUCCESS: 'PACKAGE.CREATE_PACKAGE_SAME_BARCODE.SUCCESS',
    FAILED: 'PACKAGE.CREATE_PACKAGE_SAME_BARCODE.FAILED',
};

export const CLEAR_STATE = 'PACKAGE.CREATE_PACKAGE_SAME_BARCODE.CLEAR_STATE';
